import * as React from 'react'
import PropTypes from 'prop-types'
import isExternalLink from '@/utils/isExternalLink'

import resolveAssetURL from '@/utils/resolveAssetURL'

import {
  Wrapper,
  Container,
  Title,
  Introduction,
  CircularButton, ButtonContainer
} from './style'

import Button from '@/components/Button'

const ArticleHero = ({ content, img, title, introduction = '', hideBackButton = false, cta, ctaLabel, button = false }) => {
  return (
    <Wrapper img={ resolveAssetURL(img) }>
      <Container>
        {!hideBackButton && (
          <CircularButton
            id="textcercle"
            icon='arrow-left'
            label={ ctaLabel }
            color='white'
            nbLabels={ 9 }
            to={ cta }
          />
        )}
        { title && <Title>{title}</Title>}
        {introduction && <Introduction>
          { introduction }
        </Introduction>}
        {button && (<ButtonContainer>
          <Button to={ cta } target={ isExternalLink(cta) ? '_blank' : '_self' }>{ctaLabel}</Button>
        </ButtonContainer>)}
      </Container>
    </Wrapper>
  )
}

ArticleHero.propTypes = {
  content: PropTypes.any,
  img: PropTypes.any.isRequired,
  title: PropTypes.string,
  cta: PropTypes.string,
  ctaLabel: PropTypes.string,
  introduction: PropTypes.string,
  hideBackButton: PropTypes.bool
}

export default ArticleHero
